import { addDataToArray, updateDataInArray } from 'src/utils/function.utils'
import OrderTypes from './order.types'

const INITIAL_STATE = {
	data: [],
	total: 0,
	currentPage: 1,
}

const OrderReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case OrderTypes.GET_LIST_ORDERS:
			return {
				...state,
				data: [...payload.data],
				total: payload.total,
				currentPage: payload.currentPage,
			}
		case OrderTypes.CONFIRM_ORDER: {
			const data = updateDataInArray(state.data, payload)
			return {
				...state,
				data,
			}
		}
		case OrderTypes.CREATE_ORDER_MANUAL: {
			const data = addDataToArray(state.data, payload, false)
			return {
				...state,
				data,
			}
		}
		default:
			return state
	}
}

export default OrderReducer
